/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Alert, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICookieComplianceViewProps } from '@msdyn365-commerce-modules/cookie-compliance';

const CookieComplianceView: React.FC<ICookieComplianceViewProps> = props => {
    const { CookieComplianceBanner, AlertProps, Content, acceptButton, text, links } = props;

    return (
        <Module {...CookieComplianceBanner}>
            <Alert className={AlertProps.className} color={AlertProps.color} fade={AlertProps.fade}>
                <Node {...Content}>
                        <input type='checkbox' className='ms-cookie-compliance__checkbox' onChange={() => {
                            const acceptButtonContainer = document.getElementById('ms-cookie-compliance__accept-button-container');
                            const checkbox = document.getElementsByClassName('ms-cookie-compliance__checkbox')[0] as HTMLInputElement;

                            if (acceptButtonContainer && checkbox) {
                                if (checkbox.checked) {
                                    acceptButtonContainer.classList.remove('ms-cookie-compliance__accept-button-disabled');
                                } else {
                                    acceptButtonContainer.classList.add('ms-cookie-compliance__accept-button-disabled');
                                }
                            }
                        }}></input>
                        {text}
                        {links}
                </Node>
                    <div id="ms-cookie-compliance__accept-button-container" className="ms-cookie-compliance__accept-button-disabled">
                        {acceptButton}
                    </div>
            </Alert>
        </Module>
    );
};
export default CookieComplianceView;


